/*
  TokenScopesArray
  Valid values are found under:
  AWS Console -> User Pools -> <Your user pool> -> App Integration -> App client settings
  Example values: ['profile', 'email', 'openid', 'aws.cognito.signin.user.admin', 'phone']

  RedirectUriSignOut
  This value must match the value specified under:
  AWS Console -> User Pools -> <Your user pool> -> App Integration -> App client settings -> Sign out URL(s)
*/
// var authData = {
// 	ClientId : '<TODO: add ClientId>', // Your client id here
// 	AppWebDomain : '<TODO: add App Web Domain>',
// 	TokenScopesArray : ['<TODO: add scope array>'], // e.g.['phone', 'email', 'profile','openid', 'aws.cognito.signin.user.admin'],
// 	RedirectUriSignIn : '<TODO: add redirect url when signed in>',
// 	RedirectUriSignOut : '<TODO: add redirect url when signed out>',
// 	IdentityProvider : '<TODO: add identity provider you want to specify>', // e.g. 'Facebook',
// 	UserPoolId : '<TODO: add UserPoolId>', // Your user pool id here
// 	AdvancedSecurityDataCollectionFlag : '<TODO: boolean value indicating whether you want to enable advanced security data collection>', // e.g. true
//         Storage: '<TODO the storage object>' // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
// };

var AmazonCognitoIdentity = require('amazon-cognito-auth-js');
var AWS = require('aws-sdk/global');

var authData = {
	ClientId : process.env.VUE_APP_AWS_USER_POOL_CLIENT_ID,
	AppWebDomain : process.env.VUE_APP_AWS_USER_POOL_APP_WEB_DOMAIN,
	TokenScopesArray : ['phone', 'email', 'profile','openid', 'aws.cognito.signin.user.admin'],
	RedirectUriSignIn : process.env.VUE_APP_AWS_USER_POOL_REDIRECT_URI_SIGNIN,
	RedirectUriSignOut : process.env.VUE_APP_AWS_USER_POOL_REDIRECT_URI_SIGNOUT,
	//IdentityProvider : '<TODO: add identity provider you want to specify>', // e.g. 'Facebook',
	//UserPoolId : '<TODO: add UserPoolId>', // Your user pool id here
	// AdvancedSecurityDataCollectionFlag : '<TODO: boolean value indicating whether you want to enable advanced security data collection>', // e.g. true
  //       Storage: '<TODO the storage object>' // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
};

var initAWSCredentialsFromAuthSession = function(cognitoAuthSession) {
	// Called when an identity provider has a token for a logged in user
	var creds = AWS.config.credentials;
	creds.params.Logins = creds.params.Logins || {};
	creds.params.Logins[process.env.VUE_APP_AWS_USER_POOL_IDP_ID] = cognitoAuthSession.getIdToken().getJwtToken();
	// Expire credentials to refresh them on the next request
	creds.expired = true;
	//return cognitoAuthSession;
}

const cognitoAuth = new AmazonCognitoIdentity.CognitoAuth(authData);
//cognitoAuth.useCodeGrantFlow(); //in order to refresh the user session authomatically via the Refresh token

cognitoAuth.userhandler = {
	onSuccess: initAWSCredentialsFromAuthSession,

	onFailure: function(err) {
		alert("Authentication error! " + err);
	}
};


var Auth = {

  init: function() {
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
       IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID
    });
		AWS.config.credentials.clearCachedId();

		if (cognitoAuth.getCachedSession() != null && cognitoAuth.getCachedSession().isValid()) {
			initAWSCredentialsFromAuthSession(cognitoAuth.getCachedSession());
		}

  },

  login: function() {
    cognitoAuth.getSession();
  //  console.log('Current user upon login: ' + cognitoAuth.getCurrentUser());
  },

  logout: function() {
    AWS.config.credentials.clearCachedId();
    cognitoAuth.signOut();
  },

  handleLogingResponseFromIDP: function() {
    var curUrl = window.location.href;
    cognitoAuth.parseCognitoWebResponse(curUrl);
  },

  currentUser: function() {
    return cognitoAuth.getCurrentUser();
  },

	isUserLoggedIn: function() {
		return cognitoAuth.getCachedSession().isValid();
  },

	getIdToken: function() {
		return cognitoAuth.getCachedSession().getIdToken().getJwtToken();
	}
}

export {Auth};
